<template>
  <v-container fluid>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">送信メールボックス一覧</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">メンテナンス機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12">
        <div class="px-3">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="12" xl="12" dense>
        総件数：{{items.length}}件
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          ref="dataTable"
          :headers="headers"
          :items="items"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectOutbox"
          height="450"
          :fixed-header=true
        >
          <template v-slot:item.Type="{ item }">
            {{ formatType(item.Type) }}
          </template>
          <template v-slot:item.Status="{ item }">
            {{ formatStatus(item.Status) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ formatDateToJST(item.createdAt) }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ formatDateToJST(item.updatedAt) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-dialog
      v-model="viewMessage"
      max-width="80%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          送信メッセージ詳細
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols=2 dense>種別</v-col>
            <v-col cols=10 dense><v-text-field :value="formatType(outbox.Type)" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>ステータス</v-col>
            <v-col cols=10 dense><v-text-field :value="formatStatus(outbox.Status)" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>送信者</v-col>
            <v-col cols=10 dense><v-text-field v-model="outbox.From" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>宛先</v-col>
            <v-col cols=10 dense><v-text-field v-model="outbox.To" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>CC</v-col>
            <v-col cols=10 dense><v-text-field v-model="outbox.CC" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>件名</v-col>
            <v-col cols=10 dense><v-text-field v-model="outbox.Subject" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>本文</v-col>
            <v-col cols=10 dense><v-textarea v-model="outbox.Body" readonly dense rows="20"></v-textarea></v-col>
            <v-col cols=2 dense>作成日時</v-col>
            <v-col cols=10 dense><v-text-field :value="formatDateToJST(outbox.createdAt)" readonly dense></v-text-field></v-col>
            <v-col cols=2 dense>更新日時</v-col>
            <v-col cols=10 dense><v-text-field :value="formatDateToJST(outbox.updatedAt)" readonly dense></v-text-field></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="cancel()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-close</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { fetchAllOutboxs } from '../utils/utils'
export default {

  name: "MainteOutBox",
  mixins:[],
  head: {
    title: { inner: 'Outbox一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      loading: false, 

      items: [],
      headers: [
        {
          text: '種別',
          align: 'start',
          value: 'Type',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: '送信者',
          align: 'start',
          value: 'From',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: false 
        },
        {
          text: '宛先',
          align: 'start',
          value: 'To',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: false 
        },
        {
          text: '件名',
          align: 'start',
          value: 'Subject',
          class: "grey darken-2 white--text",
          width: "20%",
          sortable: false 
        },
        {
          text: 'ステータス',
          align: 'start',
          value: 'Status',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: '作成日時',
          align: 'start',
          value: 'createdAt',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: true 
        },
        {
          text: '更新日時',
          align: 'start',
          value: 'updatedAt',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: true 
        },
      ],
      viewMessage: false,
      outbox: {},
    }
  },
  filters: {
  },
  computed: {
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
  },
  mounted: async function () {
    this.initialize()
  },
  watch: {
    page() {
      this.$nextTick(() => {
        const tableWrapper = this.$refs.dataTable.$el.querySelector('.v-data-table__wrapper')
        if (tableWrapper) {
          tableWrapper.scrollTop = 0
        }
      })
    }
  },
  methods: {
    initialize: async function() {
      this.loading = true
      try {
        let items = await fetchAllOutboxs()
        this.items = items
      } catch (error) {
        console.error('Error loading outbox items:', error)
      } finally {
        this.loading = false
      }
    },
    selectOutbox: function(data) {
      this.outbox = { ...data }
      this.viewMessage = true
    },
    cancel: function() {
      this.viewMessage = false
    },
    formatDateToJST: function(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    formatStatus: function(status) {
      const statusMap = {
        'PENDING': '送信待ち',
        'SENT': '送信済み',
        'FAILED': '送信エラー'
      }
      return statusMap[status] || status
    },
    formatType: function(type) {
      const typeMap = {
        'SIGNUP': '利用開始案内',
        'DOWNLOAD_NOTICE': '納品明細書・報告書通知',
        'ERROR': '処理エラー通知'
      }
      return typeMap[type] || type
    }
  }
};
</script>
